import ImageGridTextBlockPreview from "./ImageGridTextBlockPreview";

export default ImageGridTextBlockPreview;